import Link from 'next/link';

import { Heading, Icon, List, TextButton } from '@zillow/constellation-10';
import { IconHouseFilled } from '@zillow/constellation-icons';

import { getListingRoute } from '../../../../constants/urls';

type CongratulationsProps = {
  convertedListingAlias: string;
  handleModalReset: () => void;
};

const Congratulations = ({ convertedListingAlias, handleModalReset }: CongratulationsProps) => {
  const pathToRoute = getListingRoute({ listingAlias: convertedListingAlias });

  return (
    <>
      <Icon render={<IconHouseFilled />} css={{ marginBottom: '600' }} size="xl" />
      <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '400' }}>
        Listing converted
      </Heading>
      <List.Root>
        <List.Item>
          <TextButton asChild>
            <Link href={pathToRoute} target="_blank" rel="noopener noreferrer">
              View your converted listing
            </Link>
          </TextButton>
        </List.Item>
        <List.Item>
          <TextButton onClick={handleModalReset}>Convert another floor plan/unit</TextButton>
        </List.Item>
      </List.Root>
    </>
  );
};

export default Congratulations;
